import { Directive, HostListener } from '@angular/core';
 
@Directive({ selector: '[noSpaces]' })
export class NoSpacesDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Si la touche appuyée est la barre d'espace, on empêche l'action
    if (event.key === ' ') {
      event.preventDefault();
    }
  }
}